var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { style: { "display": "flex", "flex-direction": "row" } };
var _hoisted_2 = { style: { "flex": "1", "z-index": "2" } };
var _hoisted_3 = { class: "text-center" };
var _hoisted_4 = { class: "text-center mt-4" };
import taccuinoSchema from "@/../../EshJSLib/models/form/taccuinoForm.json";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, reactive, onMounted } from "vue";
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { useRouter } from "vue-router";
import { getTaccuinoImage } from "@/../../EshJSLib/services/taccuinoService";
import taccuinoView from '@/views/Taccuino/taccuinoView.vue';
import taccuinoLock from '@/views/Taccuino/taccuinoLock.vue';
import { Modal } from "flowbite-vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TaccuinoPage',
    setup: function (__props) {
        var _this = this;
        var router = useRouter();
        var isShownModalSub = reactive({
            alert: false,
            movePage: false,
            confirm: false,
            alertMove: false,
        });
        function movePage() {
            router.push({ path: 'Paypal' });
        }
        var showLoading = ref(false);
        var viewModal = ref(null);
        var alertModal = ref(null);
        var lockModal = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var imageDataUrl = ref("");
        var imageDataBackUrl = ref("");
        var isShowModal = reactive({
            base: false,
            delete: false,
            confidenzialita: false,
            showImage: false,
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            store.fetchTaccuinos();
            return [2 /*return*/];
        }); }); });
        function getImageAnteriore(row) {
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            showLoading.value = true;
                            return [4 /*yield*/, getTaccuinoImage(row.id_taccuino).then(function (result) {
                                    showLoading.value = false;
                                    imageDataUrl.value = result.taccuino_report_anteriore;
                                    imageDataBackUrl.value = result.taccuino_report_posteriore;
                                    var rowValue = patient.value.tbl_taccuinos.find(function (taccuino) { return taccuino.id_taccuino === Number(result.id_taccuino); });
                                    patient.value.tbl_taccuinos[0].taccuino_report_anteriore = result.taccuino_report_anteriore;
                                    patient.value.tbl_taccuinos[0].taccuino_report_posteriore = result.taccuino_report_posteriore;
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error fetching image:", error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function action(type, row, index, table) {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log("Save  page taccuin o " + type);
                            _a = type;
                            switch (_a) {
                                case "trash": return [3 /*break*/, 1];
                                case "pen": return [3 /*break*/, 2];
                                case "lock": return [3 /*break*/, 4];
                                case 'add': return [3 /*break*/, 5];
                                case 'eye': return [3 /*break*/, 7];
                            }
                            return [3 /*break*/, 8];
                        case 1:
                            alertModal.value.openModal('Rimuovere la segnalazione?', true).then(function (input) {
                                if (input) {
                                    deleteTaccuino(row);
                                }
                            });
                            return [3 /*break*/, 8];
                        case 2: return [4 /*yield*/, hasPermission('modificataccuino')];
                        case 3:
                            if (_b.sent()) {
                                router.push("/Registro/Taccuino/".concat(row.id_taccuino));
                            }
                            else {
                                isShownModalSub.alert = true;
                            }
                            return [3 /*break*/, 8];
                        case 4:
                            lockModal.value.openModal('', index).then(function (input) {
                                store.fetchTaccuinos();
                            });
                            return [3 /*break*/, 8];
                        case 5: return [4 /*yield*/, hasPermission('aggiungitaccuino')];
                        case 6:
                            if (_b.sent()) {
                                router.push("/Registro/Taccuino/Nuova");
                            }
                            else {
                                isShownModalSub.alert = true;
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            getImageAnteriore(row).then(function (result) {
                                viewModal.value.openModal('', imageDataUrl.value, imageDataBackUrl.value);
                            });
                            return [3 /*break*/, 8];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        }
        function deleteTaccuino(row) {
            row.deleted_at = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));
            row.id_paziente = patient.value.id_paziente;
            var delid = row.id_taccuino;
            store.savePaziente("tbl_taccuinos", row.id_taccuino).then(function (x) {
                store.fetchTaccuinos();
            });
            patient.value.tbl_taccuinos = patient.value.tbl_taccuinos.filter(function (vac) { return vac.id_taccuino != delid; });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(AlertModal, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512),
                    _createVNode(taccuinoView, {
                        ref_key: "viewModal",
                        ref: viewModal
                    }, null, 512),
                    _createVNode(taccuinoLock, {
                        ref_key: "lockModal",
                        ref: lockModal
                    }, null, 512),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(CollapsibleItem, {
                            id: "taccuinoCollaps",
                            data: _unref(taccuinoSchema),
                            onRowActions: _cache[0] || (_cache[0] = function (n, r, i) { return action(n, r, i, 'taccuinos'); }),
                            onCreateForm: _cache[1] || (_cache[1] = function ($event) { return (action('add', '', 0, 'taccuinos')); })
                        }, null, 8, ["data"])
                    ])
                ]),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true),
                (isShownModalSub.alert)
                    ? (_openBlock(), _createBlock(_unref(Modal), {
                        key: 1,
                        onClose: _cache[4] || (_cache[4] = function ($event) { return (isShownModalSub.alert = false); })
                    }, {
                        body: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("button", {
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return (isShownModalSub.alert = false); }),
                                    type: "button",
                                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                                }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                _createElementVNode("button", {
                                    onClick: _cache[3] || (_cache[3] = function ($event) { return (movePage()); }),
                                    type: "button",
                                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                            ])
                        ]; }),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
